import React, { Component } from 'react';

export default class view extends Component {
	render() {
		return (
			<div  style={{textAlign:'left', overflowWrap: 'break-word' }}>
				<p>The code you entered is for an infant formula and the member is not an infant. </p>
				
				<div className="button" onClick={()=>this.props.navigate( 'D18A')}>Continue</div>
			</div>
		);
	}
}